var exports = {
  "RZ": "delegationNote__egcp1U",
  "xJ": "nestedTeamList__QtA172",
  "me": "separator__vpE2W0",
};

module.exports = exports;
